// Ролі, яким доступна сервісна сторінка фіче-флагів GrowthBook (разом з mixin_isGodMode і прапорцем
// growthbookFeaturesPage — їх перевіряють напряму там, де використовують міксин).
// QA / ADMIN приходять у tenderSettings.accessRole, IT — у purchasingUser.accessRoles і потрапляє в ACL
// (setPurchCredentials), тож IT перевіряємо в обох місцях
const GROWTHBOOK_FEATURES_ROLES = ['IT', 'QA', 'ADMIN']

export default {
  computed: {
    $_hasGrowthbookFeaturesRole() {
      const accessRoles = this.$store.getters.GET_USER?.tenderSettings?.accessRole || []
      return this.$acl.check('IT')
        || accessRoles.some(role => GROWTHBOOK_FEATURES_ROLES.includes(String(role).trim()))
    },
  },
}
